import { render, staticRenderFns } from "./BlackManager.vue?vue&type=template&id=0564f8e0&"
import script from "./BlackManager.vue?vue&type=script&lang=js&"
export * from "./BlackManager.vue?vue&type=script&lang=js&"
import style0 from "./BlackManager.vue?vue&type=style&index=0&id=0564f8e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports